import * as flexsearch from "flexsearch";

import { search as searchApi } from "apis-v2/callables";
import { IWorkspaceResourceAsset, IWorkspaceResourceWithDocument } from "common/interfaces";
import { ISharedAssetsSearchDocument } from "common/interfaces/search/ISearchDocument";

import { BaseWorkspaceResourcesController, BaseWorkspaceResourcesControllerState } from "./BaseWorkspaceResourcesController";

export type ISharedAssetsPaneAsset = null;

export type SharedAssetsPaneControllerState = BaseWorkspaceResourcesControllerState<ISharedAssetsPaneAsset, IWorkspaceResourceAsset>;

class SharedAssetsPaneController extends BaseWorkspaceResourcesController<ISharedAssetsPaneAsset, IWorkspaceResourceAsset, ISharedAssetsSearchDocument> {
    protected get _documentFields() {
        return [];
    }

    protected get _batchSize() {
        return 20;
    }

    protected _searchDocumentToResourceWithDocument(searchDocument: ISharedAssetsSearchDocument): IWorkspaceResourceWithDocument<ISharedAssetsPaneAsset, IWorkspaceResourceAsset> {
        return {
            resource: searchDocument.resource,
            permission: searchDocument.permission,
            document: null,
        };
    }

    protected async _fetchSearchIndex({ locale, workspaceId }: { locale: string, workspaceId: string }): Promise<{ indexConfig: flexsearch.DocumentOptions<any>, indexFileReadUrl: string }> {
        return searchApi.getSharedAssetsSearchIndex({ workspaceId, locale });
    }
}

const sharedAssetsPaneController = new SharedAssetsPaneController();
export default sharedAssetsPaneController;
